import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';

import {
  GetPdpRecommendGroup_related_item_list_PDPRecommendGroup as PDPRecommendGroup,
  PdpComponentType,
  PDPGoodsGroup,
} from '../graphql/related-product-recommend-group_types.2';
import { QueryOptions, queryOptions as defaultQueryOptions } from '../lib/queryHelpers';
import {
  GetPdpRelatedProductRecommendGroupParams,
  PdpRelatedProductRecommendGroupQueryOption,
} from '../repositories/related-product-recommend-group';

interface Params extends GetPdpRelatedProductRecommendGroupParams {
  isSelectedShop?: boolean;
}

const DEFAULT_DATA: PDPGoodsGroup[] = [
  {
    position: 0,
    group_type: '',
    main_title: { text: '' },
    sub_title: { text: '' },
    more_button: { text: '', link_url: '' },
    type: PdpComponentType.UX_GOODS_GROUP,
    goods_carousel: { component_list: [] },
    is_ad: false,
  },
];

const DEFAULT_LIST: PDPRecommendGroup = {
  top_area: DEFAULT_DATA,
  bottom_area: DEFAULT_DATA,
  seller_coordi: DEFAULT_DATA,
  first_order: DEFAULT_DATA,
};

export const usePdpRelatedProductRecommendGroups = (
  { catalog_product_id, group_type_list, isSelectedShop }: Params,
  options?: GqlRequestOptions,
  queryOptions?: QueryOptions,
) => {
  const groupTypeList = isSelectedShop ? ['selected_item_list'] : group_type_list;

  const response = useQuery(
    PdpRelatedProductRecommendGroupQueryOption({ catalog_product_id, group_type_list: groupTypeList }, options, {
      ...defaultQueryOptions,
      ...queryOptions,
    }),
  );

  const data = response.data as PDPRecommendGroup[];

  if (response.error || !response.data || !response.data.length) {
    return {
      ...response,
      top_area: DEFAULT_LIST.top_area as PDPGoodsGroup[],
      bottom_area: DEFAULT_LIST.bottom_area as PDPGoodsGroup[],
      seller_coordi: DEFAULT_LIST.seller_coordi as PDPGoodsGroup[],
      first_order: DEFAULT_LIST.first_order as PDPGoodsGroup[],
      has_recommend_items: false,
    };
  }

  const top_area = (data[0].top_area ?? DEFAULT_LIST.top_area) as PDPGoodsGroup[];
  const bottom_area = (data[0].bottom_area ?? DEFAULT_LIST.bottom_area) as PDPGoodsGroup[];
  const has_recommend_items = Boolean(bottom_area[0]?.goods_carousel.component_list.length);
  const seller_coordi = (data[0].seller_coordi ?? DEFAULT_LIST.seller_coordi) as PDPGoodsGroup[];
  const first_order = (data[0].first_order ?? DEFAULT_LIST.first_order) as PDPGoodsGroup[];

  return {
    ...response,
    top_area,
    bottom_area,
    seller_coordi,
    first_order,
    has_recommend_items,
  };
};
